import styles from './loading.module.scss';
export default function LandingLoading() {
  return <div className={styles.root} role="status" aria-live="polite" aria-label="Loading landing page" data-sentry-component="LandingLoading" data-sentry-source-file="loading.tsx">
            <section className={styles.hero}>
                <div className={`${styles.shimmer} ${styles.searchPill}`} aria-hidden="true" />
            </section>

            <section className={styles.carousel} aria-hidden="true">
                <div className={styles.carouselHeader}>
                    <div className={`${styles.shimmer} ${styles.carouselTitle}`} />
                    <div className={styles.navButtons}>
                        <div className={`${styles.shimmer} ${styles.navBtn}`} />
                        <div className={`${styles.shimmer} ${styles.navBtn}`} />
                    </div>
                </div>

                <div className={styles.cards}>
                    {[0, 1, 2, 3, 4, 5].map(i => <div key={i} className={styles.card}>
                            <div className={`${styles.shimmer} ${styles.cardImage}`} />
                            <div className={`${styles.shimmer} ${styles.cardLine} ${styles.cardLine1}`} />
                            <div className={`${styles.shimmer} ${styles.cardLine} ${styles.cardLine2}`} />
                            <div className={`${styles.shimmer} ${styles.cardLine} ${styles.cardLine3}`} />
                        </div>)}
                </div>
            </section>
        </div>;
}